import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMessage, setSubscribeMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('company_alt') as string || '').trim();

    if (honeypotValue) {
      setSubscribeStatus('success');
      setSubscribeMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setSubscribeStatus('loading');

    try {
      const payload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'company_alt') {
          payload.append(key, value as string);
        }
      });

      const response = await fetch('http://jhequip.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';

      if (response.ok && parsed?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
        setSubscribeStatus('error');
        setSubscribeMessage('提交失败，请稍后再试。');
      } else {
        setSubscribeStatus('error');
        setSubscribeMessage(parsed?.meta?.detail || parsed?.meta?.message || '订阅失败，请稍后再试。');
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <footer className="bg-background-900 rounded-t-3xl mt-10 md:mt-14">
      <div className="mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold font-heading text-white tracking-tight whitespace-nowrap">
                36漫画
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed mb-4">
              36漫画网 — 国内领先的韩国漫画在线阅读平台。无删减、下拉式阅读、海量韩漫资源，让每一位中文读者畅享最优质的韩漫体验。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-5">
              <a href="/category/all" className="hover:text-primary-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: '热门漫画', href: '/category/all?sort=rating' },
                { label: '最新上架', href: '/category/all?sort=newest' },
                { label: '已完结', href: '/category/all?status=completed' },
                { label: '连载中', href: '/category/all?status=ongoing' },
                { label: '关于我们', href: '/about' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="text-foreground-400 hover:text-white text-sm transition-colors duration-200 whitespace-nowrap">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-5">
              <a href="/category/all" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: '都市漫画', href: '/category/dushi' },
                { label: '恋爱漫画', href: '/category/lianai' },
                { label: '奇幻漫画', href: '/category/qihuan' },
                { label: '悬疑漫画', href: '/category/xuanyi' },
                { label: '穿越漫画', href: '/category/chuanyue' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="text-foreground-400 hover:text-white text-sm transition-colors duration-200 whitespace-nowrap">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-5">邮件订阅</h4>
            <p className="text-foreground-400 text-sm mb-4 leading-relaxed">
              订阅我们的邮件，第一时间获取最新韩漫更新通知和独家优惠。
            </p>
            <form
             
              onSubmit={handleSubscribe}
              className="flex flex-col gap-3"
            >
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱"
                  required
                  className="flex-1 px-4 py-2.5 text-sm rounded-full bg-background-800 border border-background-700 text-white placeholder:text-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all duration-200"
                />
                <button
                  type="submit"
                  disabled={subscribeStatus === 'loading'}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 disabled:opacity-60 transition-colors duration-200 cursor-pointer flex-shrink-0"
                >
                  {subscribeStatus === 'loading' ? (
                    <i className="ri-loader-4-line text-white animate-spin text-sm"></i>
                  ) : (
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  )}
                </button>
              </div>
              <input
                type="text"
                name="company_alt"
                className="hp-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              {subscribeStatus === 'success' && (
                <p className="text-green-400 text-xs">{subscribeMessage}</p>
              )}
              {subscribeStatus === 'error' && (
                <p className="text-red-400 text-xs">{subscribeMessage}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 36漫画网 — 版权所有 | 让每一部韩漫，都被完整看见
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-500 hover:text-white transition-colors text-xs whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-foreground-500 hover:text-white transition-colors text-xs whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-foreground-500 hover:text-white transition-colors text-xs whitespace-nowrap" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden h-16 flex items-end justify-center pointer-events-none select-none">
        <span className="text-background-800 text-6xl md:text-8xl font-black font-heading tracking-wider opacity-30 leading-none pb-2 whitespace-nowrap">
          36漫画
        </span>
      </div>
    </footer>
  );
}